export class RestoreGoogleWorkspaceSharedDriveRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        },
        {
            "name": "restoreMode",
            "baseName": "restoreMode",
            "type": "WorkspaceRestoreMode",
            "format": ""
        },
        {
            "name": "restoreTargetFolder",
            "baseName": "restoreTargetFolder",
            "type": "string",
            "format": ""
        },
        {
            "name": "preserveFolderHierarchy",
            "baseName": "preserveFolderHierarchy",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceSharedDriveRequest.attributeTypeMap;
    }
    constructor() {
    }
}
